// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__jAyDe","spinner":"LoadingSpinner_spinner__q4KXz","spin":"LoadingSpinner_spin__pAGXf"};